import React, { Component, Fragment } from 'react';
import PropTypes from "prop-types";
import _ from "lodash";
import { PostRequestResolve } from '../../../utils/FetchHelper';
import URL from '../../../utils/url';
import DashboardContext from './Context';
import { Spin } from 'antd';
import { GetSelectedDashboard, SetIsGlobalDashboard, SetSelectedDashboard } from '../../../utils/globalDashboardUtils';

// All Details related to Dashboard
class DashboardContextWrapper extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dashboardList: [],
            loadingDashboardList: false,
            selectedDashboard: undefined,
            onChangeDashboard: this.onChangeDashboard,
            appDetails: undefined,
            loadingAppDetails: true,
            statusMessage: "",
            errorMessage: "",
            isGlobalDashboard: false,
            getServerDeploymentName: this.getServerDeploymentName,
        };
    }

    getServerDeploymentName = () => {
        const { appDetails, isGlobalDashboard, selectedDashboard, dashboardList } = this.state;
        if (isGlobalDashboard) {
            if (!selectedDashboard) {
                return null;
            }
            // Find dashboard
            const dashboard = _.find(dashboardList, d => _.get(d, "id", "") === selectedDashboard) 
            return _.get(dashboard, "details.deploymentInfo.name", null)
        }
        return _.get(appDetails, "deploymentInfo.name", {});
    }

    controller = new window.AbortController();

    getAppInfo = async () => {
        this.setState({
            loadingAppDetails: true,
            errorMessage: "",
            statusMessage: "Getting App Details"
        });
        PostRequestResolve(URL.getAppDetails, this.controller.signal).then((resp) => {
            const isGlobalDashboard = _.get(resp, "isGlobalDashboard", false);
            SetIsGlobalDashboard(isGlobalDashboard);
            if (isGlobalDashboard) {
                this.getAdminDashboards(isGlobalDashboard);
            }
            this.setState({
                appDetails: resp,
                loadingAppDetails: false,
                isGlobalDashboard: isGlobalDashboard,
            })
        }).catch((err) => {
            console.error(err);
            this.setState({
                appDetails: undefined,
                loadingAppDetails: false,
                errorDetails: `Error getting App Details: ${err}`
            })
        });
    }

    getAdminDashboards = async (isGlobalDashboard) => {
        if (!isGlobalDashboard) {
            return
        }
        this.setState({
            loadingDashboardList: true,
            errorMessage: "",
            statusMessage: "Getting List of the Dashboards"
        });
        PostRequestResolve(URL.listDashboards, this.controller.signal, null).then((resp) => {
            // Check if response is array or not
            let selectedDashboard = GetSelectedDashboard();
            if (selectedDashboard) {
                if (_.findIndex(resp, r => _.get(r, "id") === selectedDashboard) === -1) {
                    selectedDashboard = "";
                    SetSelectedDashboard("");
                }
            }
            this.setState({
                loadingDashboardList: false,
                dashboardList: resp,
                selectedDashboard: selectedDashboard,
            })
        }, (err) => {
            console.error(err);
            this.setState({
                loadingDashboardList: false,
            })
        })
    };

    onChangeDashboard = (value) => {
        SetSelectedDashboard(value);
        this.setState({
            selectedDashboard: value,
        }, () => {
            window.location.reload(false);
        });
    }

    componentDidMount() {
        this.getAppInfo()
    }

    componentWillUnmount() {
        this.controller.abort();
    }

    static propTypes = {
        children: PropTypes.node,
    }

    static defaultProps = {
        children: <Fragment />,
    };

    render() {
        const { children } = this.props;
        const { loadingAppDetails, loadingDashboardList, statusMessage } = this.state;
        return (
            <DashboardContext.Provider value={this.state}>
                <Fragment key={"dashboardContext"}>
                    {(loadingAppDetails || loadingDashboardList) ? (
                        <div style={{ display: "flex", height: "100%" }}>
                            <div style={{ flexDirection: 'column', margin: "auto", display: "flex", alignContent: "center", gap: "8px" }}>
                                <Spin />
                                {statusMessage}
                            </div>
                        </div>
                    ) : children}
                </Fragment>
            </DashboardContext.Provider>
        );
    }
}

export default DashboardContextWrapper;